var _path, _path2, _path3, _feFlood, _feColorMatrix, _feOffset, _feGaussianBlur, _feComposite, _feColorMatrix2, _feBlend, _feBlend2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPdfIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: `url(#${_id})`
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.063 1.997a1.32 1.32 0 011.32-1.32h9.68l5.5 4.62v16.06a1.32 1.32 0 01-1.32 1.32H5.383a1.32 1.32 0 01-1.32-1.32V1.997z",
    fill: "#FA5655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.063.677v3.3a1.32 1.32 0 001.32 1.32h4.18",
    fill: "#DF2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.441 19.586c-.28 0-.56-.092-.831-.271-.565-.376-.67-.847-.66-1.176.038-1.158 1.602-2.336 2.996-3.159.159-1.008.24-2.1.231-3.12-1.16-1.034-2.421-2.434-2.266-3.53.044-.306.213-.724.772-.981a1.43 1.43 0 01.602-.141c1.145 0 1.822 1.48 1.914 4.174a19.995 19.995 0 002.586 1.848c.829-.275 1.928-.568 2.848-.568.704 0 1.221.176 1.538.523.173.19.37.53.321 1.06-.073.803-.635 1.282-1.503 1.282-1.006 0-2.32-.609-3.313-1.167a19.84 19.84 0 00-2.796 1.274c-.346 1.858-1.044 3.951-2.439 3.952zm1.218-3.203c-.676.465-2.17 1.614-1.479 2.072.705.468 1.27-1.267 1.48-2.072zm5.421-2.458c.68.318 2.316.975 2.385.225.068-.742-1.667-.405-2.385-.225zm-4.006.407a.058.058 0 00.058.003c.449-.224.905-.432 1.367-.624a.058.058 0 00.036-.048c-.437-.288-.862-.591-1.277-.91a.063.063 0 00-.063-.007c-.02.53-.06 1.059-.12 1.586zM9.116 8.285c-.613.282.507 1.574.973 2.06-.079-.668-.363-2.342-.973-2.06z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: _id,
    x: -1,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2345_12993"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2345_12993",
    result: "shape"
  })))));
}
export default SvgPdfIcon;